
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import DailyNumberDisplayerFilterable from '@/components/reports-v3/components/filterables/DailyNumberDisplayerFilterable.vue';
import moment from 'moment';
import FilterWidget from '@/components/reports-v3/components/codedWidgets/shared/FilterWidget.vue';
import {PermissionsGroup} from '@/store/models.def';
import {getTableName} from '@/worker/db/sqlHelpers';

@Component({
	components: {
		DailyNumberDisplayerFilterable,
	},
})
export default class DashboardCashInBankDisplayer extends FilterWidget {
    public get permissionIds(): PermissionsGroup[] {
        return ['dashboard'];
    }

	public filterIds: Array<
		| 'date'
		| 'dateAsOf'
		| 'dateRange'
		| 'stockItems'
		| 'agents'
		| 'customers'
		| 'suppliers'
		| ''
	> = [''];

	public todayAmount = 0;

	public get expensiveHook() {
		const { selectedAsOfDate } = this;
		return JSON.stringify([selectedAsOfDate]);
	}

	public async expensiveCalc() {
		this.generateLoadingText(0.2, 0.3);

		const table = getTableName('dashboardCashBalance');

		const jobId = this.currentJobId;
		const queryHead = await this._ensureTablesLoaded(['dashboardCashBalance']);
		this.checkInterrupted(jobId);
		this.generateLoadingText(0.5);

		const result = await queryHead.rawQuery(`
			SELECT SUM(TRY_CAST("NETAMT" AS DOUBLE)) as total
			FROM ${table}
			WHERE TRY_CAST("DOCDATE" AS BIGINT) <= ${this.selectedAsOfDate}
				AND "SPECIALACCTYPE" = 'BA'
		`);
		this.checkInterrupted(jobId);

		this.todayAmount = Number(result[0] && result[0].total) || 0;

		this.generateLoadingText(1);
		this.saveHistory('todayAmount');
	}
}
